class Accordion extends HTMLElement {
  constructor() {
    super();
    this.accordions = document.querySelectorAll(".accordion");

    this.openAccordion = (accordion) => {
      const content = accordion.querySelector(".accordion__content");
      accordion.classList.add("accordion__active");
      content.style.maxHeight = content.scrollHeight + "px";
    };

    this.closeAccordion = (accordion) => {
      const content = accordion.querySelector(".accordion__content");
      accordion.classList.remove("accordion__active");
      content.style.maxHeight = null;
    };

    this.accordions.forEach((accordion) => {
      const intro = accordion.querySelector(".accordion__intro");
      const content = accordion.querySelector(".accordion__content");

      intro.onclick = () => {
        if (content.style.maxHeight) {
          this.closeAccordion(accordion);
        } else {
          this.accordions.forEach((accordion) =>
            this.closeAccordion(accordion)
          );
          this.openAccordion(accordion);
        }
      };
    });
  }
}

customElements.define("accordion-element", Accordion);